export default __webpack_public_path__ + "static/media/feedpushr.581009c2.svg";